import { render, staticRenderFns } from "./MessageTemplateCreate.vue?vue&type=template&id=577d31ec&scoped=true"
import script from "./MessageTemplateCreate.vue?vue&type=script&lang=js"
export * from "./MessageTemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateCreate.vue?vue&type=style&index=0&id=577d31ec&prod&lang=stylus&scoped=true"
import style1 from "./MessageTemplateCreate.vue?vue&type=style&index=1&id=577d31ec&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d31ec",
  null
  
)

export default component.exports